import { FC } from 'react';
import { PROTECTED_MODE } from '@silverfort-nodelibs/common/utils/consts';
import { Badge, Tooltip } from '@silverfort/sf-components';

interface ProtectionBadgeProps {
    isProtected: boolean;
    protectedMode: number;
    smartPolicyName?: string;
}

const ProtectionBadge: FC<ProtectionBadgeProps> = ({ isProtected, protectedMode, smartPolicyName }) => {
    if (isProtected) {
        if (protectedMode === PROTECTED_MODE.BY_SMART_POLICY) {
            if (smartPolicyName) {
                return (
                    <div className="flex gap-1">
                        <Tooltip title={`Protected by Smart policy: ${smartPolicyName}`}>
                            <Badge className="w-fit" icon={'SmartPolicy'} color="positive" text="Protected" />
                        </Tooltip>
                    </div>
                );
            } else {
                return <Badge className="w-fit" icon={'SmartPolicy'} color="positive" text="Protected" />;
            }
        } else {
            return <Badge className="w-fit" color="positive" text="Protected" />;
        }
    }
    return <Badge className="w-fit" color="negative" text="Unprotected" />;
};

export default ProtectionBadge;
